import Vue from 'vue'

import { getGetters } from '../plugins/mapGetter'

const helperMixin = {
  computed: {
    ...getGetters(),
  },
  watch: {
    'idMarked': {
      deep: true,
      handler(seft) {
        this.$store.dispatch('globalCheckAction', seft)
      },
    },
    'eventStatus': function (status) {
      // Al completar la actualización de estado se restablece
      if (this.loadingEventStatusUpdate === false && this.checkVariable(status)) {
        this.idMarked = []
      }
    },
  },
  methods: {
    _getIds(idMarked) {
      const arrVal = []
      Object.keys(idMarked).forEach(key => {
        if (this.checkVariable(idMarked[key])) {
          arrVal.push(idMarked[key])
        }
      })

      return arrVal
    },
    markAll(collection, idMarked, key) {
      if (!this.isArray(idMarked)) {
        idMarked = []
      }
      if (!this.checkVariable(key)) {
        key = 'id'
      }
      let sw = idMarked.length > 0 ? true : false
      if (this.checkVariable(collection, collection.data) && this.isArray(collection.data)) {
        collection.data.forEach(data => {
          const result = this.getFirstOccurrence(idMarked, this.getObjectValue(data, key))
          if (!this.checkVariable(result)) {
            const value = this.getObjectValue(data, key)
            if (sw === true) {
              const index = this.getIndexOf(idMarked, null)
              if (index !== -1) {
                idMarked.splice(index, 1, value)
              } else {
                this.$set(idMarked, `id-${value}`, value)
              }
            } else {
              this.$set(idMarked, `id-${value}`, value)
            }
          }
        })
      }
    },
    _setLocalMarkAll(form, idMarked) {
      if (this.isObject(form) && this.getAmountOfKeys(idMarked) > 0) {
        const arrVal = []
        Object.keys(idMarked).forEach(key => {
          if (this.checkVariable(idMarked[key])) {
            arrVal.push(idMarked[key])
          }
        })
        form['id_marked'] = arrVal
      }

      return form
    },
    approveRequest(urlStatusUpdate, idMarked, collection) {
      if (this.checkVariable(urlStatusUpdate, idMarked)) {
        let form = this.createAdvancedFilter(this.filterable.url)
        form = this._setLocalMarkAll(form, idMarked)
        this.captureDataToRevertFilter(idMarked, collection)

        this.$store.dispatch(
          'eventStatusUpdate',
          {
            url: urlStatusUpdate,
            params: { ...form, destination_status: 2 },
          },
        )

        this.$root.$emit('triggerSwitchRevertDataToast', true)
      }
    },
    toRefuse(urlStatusUpdate, idMarked, collection) {
      if (this.checkVariable(urlStatusUpdate, idMarked)) {
        let form = this.createAdvancedFilter(this.filterable.url)
        form = this._setLocalMarkAll(form, idMarked)
        this.captureDataToRevertFilter(idMarked, collection)

        this.$store.dispatch(
          'eventStatusUpdate',
          {
            url: urlStatusUpdate,
            params: { ...form, destination_status: 3 },
          },
        )

        this.$root.$emit('triggerSwitchRevertDataToast', true)
      }
    },
    toClose(urlStatusUpdate, idMarked, collection) {
      if (this.checkVariable(urlStatusUpdate, idMarked)) {
        let form = this.createAdvancedFilter(this.filterable.url)
        form = this._setLocalMarkAll(form, idMarked)
        this.captureDataToRevertFilter(idMarked, collection)

        this.$store.dispatch(
          'eventStatusUpdate',
          {
            url: urlStatusUpdate,
            params: { ...form, destination_status: 4 },
          },
        )

        this.$root.$emit('triggerSwitchRevertDataToast', true)
      }
    },
    captureDataToRevertFilter(idsMarked, collection) {
      const columnsToAsign = ['estado_material_id', 'fecha_modificacion_estado']
      const recordsToRevert = this.createRecordsArrayToRevertFromFilterableCollection(idsMarked, collection, columnsToAsign)

      this.captureDataToRevert('asign_requests', recordsToRevert, 'Se cambió el estado de los registros seleccionados.', this.urlRevert)
    },
    /**
     * @param {Array} filter
     * @param {String} defaultValue
     * @return {Object}
     */
    createSearchFilter(filter, defaultValue) {
      let newQuery = {}
      const allFilter = { f: {} }
      filter.forEach((f, i) => {
        allFilter['f'][i] = {
          column: this.checkVariable(f.name) ? f.name : null,
          operator: this.checkVariable(f.operator) ? f.operator : null,
          query_1: defaultValue,
        }
      })
      newQuery = { ...newQuery, ...allFilter }

      return newQuery
    },
    /**
     * @returns {*}
     */
    getCurrentRouteDetail() {
      const _this = this
      const { options } = _this.$router
      if (!_this.checkVariable(options)) {
        return null
      }
      if (!_this.isArray(options.routes)) {
        return null
      }
      const current = _this.$route
      const result = _this.findWith(options.routes, ob => {
        const { name } = ob
        if (_this.checkVariable(name)) {
          return name === current.name
        } else {
          if (_this.checkVariable(ob.children) && _this.isArray(ob.children)) {
            const insResult = _this.findWith(ob.children, obChildren => {
              if (_this.checkVariable(obChildren.name)) {
                return obChildren.name === current.name
              }

              return false
            })

            return insResult !== -1
          }

          return false
        }
      })

      return result !== -1 ? options.routes[result] : null
    },
    /**
     * @returns {*}
     */
    getSearchDetail() {
      const route = this.getCurrentRouteDetail()
      if (!this.isObject(route)) {
        return null
      }

      let finder = this.getObjectValue(route, 'finder')
      if (!this.checkVariable(finder)) {
        finder = this.finderDefault
      }

      return finder
    },
    goResource(clientPath) {
      const _this = this
      let jpath = null
      if (!_this.isObject(clientPath)) {
        jpath = JSON.parse(clientPath)
      }

      const to = _this.$router.resolve(jpath)

      _this.$router.push({ ...to.location })
        .then(() => {
          _this.$store.dispatch('setUpdateStatus', _this.generateRandomNumber(10))
        })
        .catch(() => { })

    },
  },
}

const Component = Vue.extend({
  name: 'new-global-actions-filter',
  mixins: [helperMixin],
})

export default Component
